import { AgreeToTermsPolicy } from '@logto/schemas';
import { useCallback } from 'react';

import TextLink from '@/components/TextLink';
import useNavigateWithPreservedSearchParams from '@/hooks/use-navigate-with-preserved-search-params';
import { useSieMethods } from '@/hooks/use-sie';
import useTerms from '@/hooks/use-terms';

type Props = {
  readonly className?: string;
};

/**
 * Entry point of the single sign-on flow. Renders nothing when single sign-on is disabled
 * in the sign-in experience config.
 */
const SingleSignOnLink = ({ className }: Props) => {
  const { singleSignOnEnabled } = useSieMethods();
  const { termsValidation, agreeToTermsPolicy } = useTerms();
  const navigate = useNavigateWithPreservedSearchParams();

  const handleClick = useCallback(async () => {
    /**
     * Check if the user has agreed to the terms and privacy policy before navigating to the SSO page
     * when the policy is set to `Manual`
     */
    if (agreeToTermsPolicy === AgreeToTermsPolicy.Manual && !(await termsValidation())) {
      return;
    }

    navigate('/single-sign-on/email');
  }, [agreeToTermsPolicy, navigate, termsValidation]);

  if (!singleSignOnEnabled) {
    return null;
  }

  return <TextLink className={className} text="action.sign_in_with_sso" onClick={handleClick} />;
};

export default SingleSignOnLink;
